<template>
  <div class="personinfo">
    <mt-header :title="title" class="fixedtop">
      <mt-button icon="back" slot="left" @click.native="back"></mt-button>
    </mt-header>
    <div class="infobody">
      <div class="titlebox" style="padding: 10px 20px;">
        <div class="line"></div>
        <h1>个人简介</h1>
      </div>
      <div class="container">
        <textarea id="desc" name="text" v-model="aboutMe" placeholder="请输入个人简介"></textarea>
        <span>100-1000</span>
      </div>
      <div class="next">
        <van-button type="info" @click="back">上一步</van-button>
        <van-button type="info" @click="save">下一步</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast, MessageBox, Indicator } from "mint-ui";
export default {
  data() {
    return {
      title: "个人信息",
      aboutMe: "",
    };
  },
  created() {
    this.$emit("footer", false);
    this.datainfo();
  },
  methods: {
    datainfo() {
      let _this = this;
      Indicator.open({
        text: "加载中...",
        spinnerType: "fading-circle",
      });
      this.axios.get("url/userName/getUserInformation?accountId=" +sessionStorage.getItem("loginId"))
        .then(function (res) {
          Indicator.close();
          _this.aboutMe = res.data.aboutMe;
        });
    },
    back() {
      this.$router.push("/skills");
    },
    save() {
      let _this = this;
      if (_this.aboutMe == "" || _this.aboutMe === undefined || _this.aboutMe === null) {
        Toast({
          message: "请输入个人简介",
          position: "middle",
          className: "indexClass",
          duration: 1000,
        });
        return false;
      } else if (_this.aboutMe.length < 100 || _this.aboutMe.length > 1000) {
        Toast({
          message: "请输入正确的个人简介",
          position: "middle",
          className: "indexClass",
          duration: 1000,
        });
        return false;
      }
      _this.axios({
          method: "POST",
          url: "/url/account/userInfo/vueUpdateUserInformation",
          timeout: 100000,
          data: {
            aboutMe: _this.aboutMe,
            updateFlag: 1,
            accountId: sessionStorage.getItem("loginId"),
          },
        })
        .then(function (res) {
          if (res.data.success) {
            _this.$router.push({ path: "/addcase" });
          } else {
            Toast({
              message: res.data.msg,
              position: "middle",
              className: "indexClass",
              duration: 1000,
            });
          }
        })
        .catch(function (res) {
          Toast({
            message: "编辑资料失败",
            position: "middle",
            className: "indexClass",
            duration: 1000,
          });
        });
    },
  },
};
</script>

<style scoped>
.fixedtop {
  position: fixed;
  top: 0;
  width: 100%;
  z-index:1000;
}
.infobody .titlebox {
  margin-top: 40px;
}
.infobody .titlebox .line {
  width: 8px;
  height: 12px;
  background: #6ba5e0;
  display: inline-block;
}
.infobody h1 {
  display: inline-block;
  font-weight: bold;
  font-size: 15px;
}
.container {
  padding: 0 20px;
}
.container span {
  float: right;
  margin-top: 10px;
  color: #7d7a7a;
}
#desc {
  height: 200px;
  border: 1px solid #ddd;
  width: 100%;
}
.next {
  position: fixed;
  text-align: center;
  bottom: 0;
  background: #fff;
  width: 100%;
  padding: 10px 0;
}
.next .van-button {
  width: 40%;
  height: 37px;
  border-radius: 5px;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// personinfo.vue?1b6604f3